(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ContractType', ContractType);

    ContractType.$inject = ['$resource'];

    function ContractType ($resource) {
        var resourceUrl =  'api/type-contrats/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
